import { useEffect } from 'react';

function useMetaDescription(description) {
  useEffect(() => {
    document.getElementById('meta-description').setAttribute('content', description);
  }, [description]);
};

export default useMetaDescription;
